// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ht0OlZTjpI9ehWhgGfdW {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  /* Ensures elements are in a row */
  align-items: center;
  /* Vertically centers the elements */
  align-self: center;
  width: var(--jp-panel-width);
  /* Fixed width for larger screens */
  min-width: var(--jp-panel-width);
  /* Fixed width for larger screens */
}
/*Responsive adjustments - using CSS variables for consistency */
@media (max-width: 1025px) {
  .ht0OlZTjpI9ehWhgGfdW {
    --jp-panel-width: 375px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/JackpotPanel/JackpotPanel.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,gCAAgC;EAChC,mCAAmC;AACrC;AACA,gEAAgE;AAChE;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".jackpotPanel {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  /* Ensures elements are in a row */\n  align-items: center;\n  /* Vertically centers the elements */\n  align-self: center;\n  width: var(--jp-panel-width);\n  /* Fixed width for larger screens */\n  min-width: var(--jp-panel-width);\n  /* Fixed width for larger screens */\n}\n/*Responsive adjustments - using CSS variables for consistency */\n@media (max-width: 1025px) {\n  .jackpotPanel {\n    --jp-panel-width: 375px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jackpotPanel": `ht0OlZTjpI9ehWhgGfdW`
};
export default ___CSS_LOADER_EXPORT___;
